<template>
  <chart v-if="data[0]" ref="chart" :options="chartOptions" />
</template>
<script>
import { Chart } from 'highcharts-vue'

export default {
  components: {
    Chart,
  },
  props: ['data'],
  data() {
    return {
      loading: false,
      chartOptions: {
        chart: {
          height: 350,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: {},
        },
        yAxis: {
          title: {
            text: 'Max. Odber DMM (m3)',
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: 2,
          valueSuffix: ' m3',
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'vykonove-data_report',
        },
      },
    }
  },
  watch: {
    data() {
      this.chartOptions.series = this.data
    },
  },
  mounted() {
    this.chartOptions.xAxis.categories = this.$helpers.monthsSk()
    this.chartOptions.series = this.data
  },
}
</script>
